export const SECTION_HEADING_CONTAINER = "py-4 mb-4";

export const HOW_IT_WORKS_ROW =
    "grid grid-cols-2 md:grid-cols-4 gap-3 lg:w-[90%] mx-3 lg:mx-auto";
